import {
  FaHandshake,
  FaHotel,
  FaPassport,
  FaPlane,
  FaPlaneDeparture,
  FaShieldAlt
} from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import './Services.css';

const Services = () => {
  const { serviceType } = useParams();

  const servicesData = {
    'international-flights': {
      icon: <FaPlane />,
      title: 'International Flights',
      description: 'Book international flights to destinations worldwide with the best airlines.',
      features: [
        'Access to 500+ airlines globally',
        'Competitive pricing with exclusive deals',
        'Multi-city and round-trip options',
        'Flexible booking and cancellation',
        'Business and Economy class options',
        '24/7 booking assistance'
      ],
      image: 'https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800'
    },
    'domestic-flights': {
      icon: <FaPlaneDeparture />,
      title: 'Domestic Flights',
      description: 'Convenient domestic flight bookings across the country at affordable prices.',
      features: [
        'All major domestic airlines',
        'Best price guarantee',
        'Quick and easy booking process',
        'Instant confirmation',
        'Flexible travel dates',
        'Special corporate rates'
      ],
      image: 'https://images.unsplash.com/photo-1464037866556-6812c9d1c72e?w=800'
    },
    'accommodation': {
      icon: <FaHotel />,
      title: 'Accommodation',
      description: 'Find and book the perfect accommodation for your stay, from budget to luxury.',
      features: [
        'Hotels, resorts, and vacation rentals',
        'Best price matching',
        'Verified customer reviews',
        'Instant booking confirmation',
        'Special honeymoon packages',
        'Corporate accommodation solutions'
      ],
      image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800'
    },
    'travel-insurance': {
      icon: <FaShieldAlt />,
      title: 'Travel Insurance',
      description: 'Comprehensive travel insurance to protect you and your trip.',
      features: [
        'Medical emergency coverage',
        'Trip cancellation protection',
        'Lost baggage compensation',
        'Emergency evacuation',
        'COVID-19 coverage available',
        'Affordable premium rates'
      ],
      image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800'
    },
    'mice': {
      icon: <FaHandshake />,
      title: 'MICE (Meetings, Incentives, Conferences & Events)',
      description: 'Professional corporate travel and event management services.',
      features: [
        'Conference and meeting planning',
        'Venue selection and booking',
        'Team building and incentive trips',
        'Event logistics management',
        'Group travel arrangements',
        'Dedicated event coordinators'
      ],
      image: 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=800'
    },
    'visa-passport': {
      icon: <FaPassport />,
      title: 'VISA & Passport Assistance',
      description: 'Expert assistance for visa applications and passport services.',
      features: [
        'Visa application support',
        'Document verification',
        'Passport renewal services',
        'Fast-track processing available',
        'Embassy liaison services',
        'Complete documentation guidance'
      ],
      image: 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=800'
    }
  };

  const service = servicesData[serviceType] || servicesData['international-flights'];

  const allServices = Object.keys(servicesData).map(key => ({
    key,
    ...servicesData[key]
  }));

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${service.image})` }}>
        <div className="service-hero-overlay">
          <div className="container">
            <div className="service-icon-large">{service.icon}</div>
            <h1 className="service-hero-title">{service.title}</h1>
            <p className="service-hero-description">{service.description}</p>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-features">
        <div className="container">
          <h2 className="section-title">What We Offer</h2>
          <div className="features-grid">
            {service.features.map((feature, index) => (
              <div key={index} className="feature-item">
                <div className="feature-check">✓</div>
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to Book?</h2>
            <p>Contact us today to get started with {service.title.toLowerCase()}</p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn btn-primary">Get in Touch</Link>
              <a href="tel:+919731395805" className="btn btn-secondary">Call Us Now</a>
            </div>
          </div>
        </div>
      </section>

      {/* Other Services */}
      <section className="other-services">
        <div className="container">
          <h2 className="section-title">Explore Our Other Services</h2>
          <div className="services-grid">
            {allServices
              .filter(s => s.key !== serviceType)
              .slice(0, 6)
              .map((s, index) => (
                <Link key={index} to={`/services/${s.key}`} className="service-card">
                  <div className="service-card-icon">{s.icon}</div>
                  <h3>{s.title}</h3>
                  <p>{s.description}</p>
                </Link>
              ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
